import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'General Dentistry',
        'description': 'Family dentistry is for patients of all ages offering complete, comprehensive dental care.',
        'path': '/general-dentistry'
    },
    {
        'icon': iconTwo,
        'title': 'Dental Implants',
        'description': 'Dental implants are a procedure of permanently replacing missing teeth without affecting neighboring teeth.',
        'path': '/dental-implants'
    },
    {
        'icon': iconThree,
        'title': 'Orthodontics',
        'description': 'Orthodontics are a specialty that correct irregularities such as crooked teeth, poorly aligned teeth, crowded teeth.',
        'path': '/orthodontics'
    },
    {
        'icon': iconFour,
        'title': 'Teeth Whitening',
        'description': 'Teeth whitening is a simple process. Whitening products contain one of two tooth bleaches.',
        'path': '/teeth-whitening'
    },
    {
        'icon': iconOne,
        'title': 'Root Canals',
        'description': 'Root canal treatment is designed to eliminate bacteria from the infected root canal, prevent reinfection and save the natural tooth.',
        'path': '/root-canals'
    },
    {
        'icon': iconTwo,
        'title': 'Wisdom Teeth',
        'description': 'Wisdom teeth removal is a surgical procedure to extract one or more wisdom teeth — the four permanent adult teeth located at the back corners of your mouth.',
        'path': '/wisdom-teeth'
    },
    {
        'icon': iconThree,
        'title': 'Veneers',
        'description': 'Dental veneers are thin, tooth-colored shells that are attached to the front surface of teeth to improve their appearance.',
        'path': '/veneers'
    },
    {
        'icon': iconFour,
        'title': 'Crowns and Bridges',
        'description': 'Dental crowns and bridges are fixed prosthetic devices that are cemented onto existing teeth or implants by a dentist or prosthodontist.',
        'path': '/crowns-and-bridges'
    },
    {
        'icon': iconOne,
        'title': 'Invisalign',
        'description': 'Invisalign is a brand of clear aligners that are custom-made for you based on your dentist\'s or orthodontist\'s prescription.',
        'path': '/invisalign'
    }
];

export default ServicesData;
